import { render, staticRenderFns } from "./sensor_attri.vue?vue&type=template&id=9ffc60a6&"
import script from "./sensor_attri.vue?vue&type=script&lang=js&"
export * from "./sensor_attri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports